module.exports = __webpack_public_path__ + "img/common.79963004.jpg";